import type { EventTypeView, MarketId, MeetingBasedMarketView } from '@ps/isp-web-services-types';
import type { Selector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { withMeetingBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/meetingBased';
import type { MeetingBasedMarketTemplatesView } from '@swf/sports/types/templates';
import { getRaceTimeFromRaceId } from '@swf/sports/utils/getRaceTimeFromRaceId';

import { defaultState } from './defaultState';
import type { RaceLinkValues } from './types';

export const selectors = withMeetingBasedMarketTemplateModelSelectors(
  defaultState,
  (slice, createSelector) => ({
    hasPreloaded: () => slice((state) => state.hasPreloaded),
    isLoading: () => slice((state) => state.isLoading),
    errorCode: () => slice((state) => state.errorCode),
    templates: () => slice((state) => state.templates),
    ukIeTemplates: () => slice((state) => state.ukIeTemplates),
    filteredTemplates: () =>
      slice((state) => state.templates.filter((template) => !template.hasFinished)),
    filteredUkIeTemplates: () =>
      slice((state) => state.ukIeTemplates.filter((template) => !template.hasFinished)),
    selectedTemplate: () => slice((state) => state.selectedTemplate),
    selectedTab() {
      return slice((state) => state.selectedTab);
    },
    raceCardLinkValues(this: {
      getMarketTemplateData: Selector<
        RootState,
        Pick<MeetingBasedMarketTemplatesView, 'markets' | 'meetings' | 'eventTypes' | 'races'>
      >;
    }) {
      return createSelector(
        this.getMarketTemplateData,
        (_state: RootState, marketId: MarketId) => marketId,
        ({ eventTypes, meetings, markets }, marketId): RaceLinkValues => {
          const { raceId, meetingId, eventTypeId } = markets[marketId] as MeetingBasedMarketView;
          const { eventTypeSlug } = eventTypes[eventTypeId] as EventTypeView;
          const { venueSlug } = meetings[meetingId];

          return {
            raceId: getRaceTimeFromRaceId(raceId),
            meetingId,
            eventTypeId: String(eventTypeId),
            eventTypeSlug,
            venueSlug
          };
        }
      );
    }
  })
);
